<template>
  <AnalyticsFrame :route-name="AnalyticsRouteName.biDashboard"></AnalyticsFrame>
</template>

<script>
export default {
  name: 'BiDashboard'
};
</script>

<script setup>
import AnalyticsFrame from '@/components/organisms/AnalyticsFrame';

import { AnalyticsRouteName } from '../../../constants';
</script>
